const apiConfig = {
  // API Base URL
  // apiBaseURL: "http://localhost:4407",
  
 //dev Api Url
  apiBaseURL: "https://devapi.giftsfromheaven.com",

  //dev ADMIN Api Url
  apiAdminBaseURL: "https://devadminapi.giftsfromheaven.com",
  
  //staging Api Url
  // apiBaseURL: "https://stagingapi.giftsfromheaven.com",
};

export default apiConfig;